// extracted by css-extract-rspack-plugin
export default {"dialog":"ReleaseNotesDialog_dialog__3ebK+","dialog-title":"ReleaseNotesDialog_dialog-title__VicT2","dialog-content":"ReleaseNotesDialog_dialog-content__T77pa"};